
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  SupplierFamily.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\SupplierFamily.ts

import {Family } from "./Family";
import {Supplier } from "./Supplier";
export class SupplierFamily {

  // int SupplierId
  public SupplierId: number=0;

  // int FamilyId
  public FamilyId: number=0;

  // byte? MainFamily
  public MainFamily?: number=null;

  // Family Family
  public Family: Family=null;

  // Supplier Supplier
  public Supplier: Supplier=null;
}